/**
 * Brix Order — constants.
 *
 * Per-flavor accent colors live here (NOT in tailwind.config.ts) because they
 * are applied inline on product cards only — never in chrome. Banned color
 * #C8102E (Alameda Soda crimson) must never appear here.
 *
 * The Melt pilot location list is duplicated here for the dev shell until we
 * read it from `orders.customer_locations`. Once auth is wired and we can
 * resolve locations from the customer, this falls away — keep it private.
 */

export const SUPPORT_PHONE = '510-564-2700';
export const SUPPORT_TEL_HREF = 'tel:5105642700';
export const SUPPORT_PHONE_TOLL_FREE = '1-800-372-5098';
export const SUPPORT_TOLL_FREE_HREF = 'tel:18003725098';
export const SUPPORT_EMAIL = 'service@brixbev.com';
export const SUPPORT_MAILTO_HREF = 'mailto:service@brixbev.com';
export const SUPPORT_ADDRESS_LINE1 = '1951 Monarch Street';
export const SUPPORT_ADDRESS_LINE2 = 'Alameda, CA 94501';

export const CATEGORIES = [
  // 'My Collection' is a personal filter (items this customer has ordered
  // before), not a real catalog category. It leads the list so returning
  // customers land on their regulars first; the pill hides itself when the
  // customer has no order history yet.
  'My Collection',
  'All',
  '3-gal BIB',
  '5-gal BIB',
  'Sugar Free',
  'Mixer',
  '24-Pack',
  'Gas',
] as const;

export type Category = (typeof CATEGORIES)[number];

/** Pilot location list — replaced by `orders.customer_locations` once auth is live. */
export const MELT_PILOT_LOCATIONS = [
  'The Melt — Long Beach #34',
  'The Melt — Burbank #28',
  'The Melt — Brea #31',
  'The Melt — Del Amo #33',
] as const;

/**
 * Per-flavor accent colors (product cards only, never chrome).
 * Diablo Black Cherry uses plum (#4A1B2E) — NOT red — per the brand rules.
 */
export const FLAVOR_ACCENTS = {
  'Hangar 25 Cola':            '#7A4A2B',
  'Hangar 25 Diet Cola':       '#3A3F45',
  'Cable Car Lemon Lime':      '#9BC53D',
  'Oaktown Root Beer':         '#5C3B26',
  'Lost Island Ginger Beer':   '#D4A24C',
  'Golden Gate Orange':        '#F26A21',
  'Olde Fountain Creme':       '#E8D5A8',
  'Diablo Black Cherry':       '#4A1B2E',
  'Grand Lake Grapefruit':     '#F5A395',
  'Docteur Poivre':            '#6B4423',
  'APT Ginger Ale':            '#D4A24C',
  'APT Tonic':                 '#C8D4D8',
} as const;
